<div class="contentSpinner" *ngIf="isLoading">
  <div class="miniSpinner" fxLayout="column" fxLayoutGap="15px"></div>
</div>
